<template>
  <div ref="editor" :value="editorContent"></div>
</template>

<script>
  import E from 'wangeditor';
  import http from '@/api/http';

  export default {
    name: "i-editor",
    props: ['value', 'content'],
    data() {
      return {
        editorContent: '',
        editor: null
      }
    },
    mounted() {
      this.editor = new E(this.$refs.editor);
      let editor = this.editor;
      editor.customConfig = {
        menus: [
          'head',  // 标题
          'bold',  // 粗体
          'fontSize',  // 字号
          'fontName',  // 字体
          'italic',  // 斜体
          'underline',  // 下划线
          'strikeThrough',  // 删除线
          'foreColor',  // 文字颜色
          'backColor',  // 背景颜色
          'link',  // 插入链接
          'list',  // 列表
          'justify',  // 对齐方式
          'quote',  // 引用
          'image',  // 插入图片
          'table',  // 表格
          'video',  // 插入视频
          'undo',  // 撤销
          'redo'  // 重复
        ],
        onchange: html => {
          this.$emit('input', html)
        },
        zIndex: 100,
        uploadFileName: 'image',
        customUploadImg: function (files, insert) {
          for (let i in files) {
            let formData = new FormData();
            formData.append('image', files[i])
            http.upload(formData).then(function (res) {
              console.log(res)
              if (res.status === 'success') {
                insert(res.data.file_url);
              }
            });
          }
        },

      };
      editor.create();
      editor.txt.html(this.value)
    },
    watch: {
      value: function () {
        this.editor.txt.html(this.value);
      }
    }
  }
</script>

<style scoped lang="less">

</style>



// WEBPACK FOOTER //
// src/components/i-editor.vue